import { createFileRoute } from '@tanstack/react-router';

import {
  exchangeRateListQueryOptions,
  exchangeRateListSearchSchema,
  ExchangeRatesPage,
} from '@/features/exchange-rates';

/** Any platform role may read the rates; owners and admins get the edit actions. */
export const Route = createFileRoute('/_authed/exchange-rates')({
  staticData: { crumbKey: 'nav.exchangeRates', tours: ['platform.exchange-rates'] },
  validateSearch: exchangeRateListSearchSchema,
  loader: ({ context }) =>
    context.queryClient.query({ ...exchangeRateListQueryOptions(), staleTime: 'static' }),
  component: ExchangeRatesPage,
});
